var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout-empty',{attrs:{"hasHeader":true,"headerType":"nested","headerTitle":_vm.headerTitle}},[_c('div',{staticClass:"col-12 col-lg-8 col-xl-6 mx-auto"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }